<template>
    <div
        v-if="errorsAreNotEmpty"
        class="flex items-center bg-red-50 px-4 py-3 rounded text-red-500 text-sm gap-3 relative" role="alert"
    >
        <template v-if="typeof errors === 'string' || errors instanceof String">
            {{ errors }}
        </template>
        <ul v-else>
            <li
                v-for="(error) in errors"
            >
                <template v-if="typeof error === 'string' || error instanceof String">
                    {{ error }}
                </template>
                <template v-else>
                    {{ error[0] || error }}
                </template>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ValidationErrors',
    props: {
        errors: {
            type: [Object, Array, String],
            default: null
        }
    },
    computed: {
        errorsAreNotEmpty() {
            if (Array.isArray(this.errors)) {
                return this.errors.length > 0
            }

            return this.errors && Object.keys(this.errors).length > 0
        }
    }
}
</script>
